<template>
    <div v-loading="loading">
        <el-form-item label="Employer">
            <el-select
                v-model="employer_id"
                filterable
                clearable
                placeholder="Select an Employer"
                style="width: 100%"
                @change="employerChanged"
            >
                <el-option
                    v-for="item in list.employers"
                    :key="item.id"
                    :label="item.label"
                    :value="item.id">
                </el-option>
            </el-select>
        </el-form-item>

        <el-form-item label="Campaign" v-if="show_campaign">
            <el-select
                v-model="campaign_id"
                filterable
                clearable
                remote
                placeholder="Select a Campaign"
                style="width: 100%"
                :disabled="! employer_id"
                @change="campaignChanged"
            >
                <el-option
                    v-for="item in list.campaigns"
                    :key="item.id"
                    :label="item.label"
                    :value="item.id">
                </el-option>
            </el-select>
        </el-form-item>

        <el-form-item label="Job" v-if="show_job">
            <el-select
                v-model="job_id"
                filterable
                clearable
                remote
                placeholder="Select a Job"
                style="width: 100%"
                :disabled="! employer_id || ! campaign_id"
                @change="jobChanged"
            >
                <el-option
                    v-for="item in list.jobs"
                    :key="item.id"
                    :label="item.label"
                    :value="item.id">
                </el-option>
            </el-select>
        </el-form-item>
    </div>
</template>

<script>
export default {
    props: {
        show_campaign: { type: Boolean, required: false, default: true },
        show_job: { type: Boolean, required: false, default: true }
    },
    data() {
        return {
            loading: false,
            employer_id: null,
            campaign_id: null,
            job_id: null,
            list: {
                employers: [],
                campaigns: [],
                jobs: [],
            }
        };
    },
    methods: {
        clearEmployers() {
            this.employer_id = null;
            this.list.employers = [];

            this.clearCampaigns();
        },
        clearCampaigns() {
            this.campaign_id = null;
            this.list.campaigns = [];

            this.clearJobs();
        },
        clearJobs() {
            this.job_id = null;
            this.list.jobs = [];
        },
        refreshEmployers() {
            this.clearEmployers();

            this.loading = true;

            return axios.get(url(`admin/job-select/employers`))
                .then((response) => {
                    this.list.employers = response.data;

                    this.loading = false;
                });
        },
        refreshCampaigns() {
            if(! this.show_campaign) {
                return;
            }

            this.clearCampaigns();

            this.loading = true;

            return axios.get(url(`admin/job-select/campaigns`), { params: { employer_id: this.employer_id }})
                .then((response) => {
                    this.list.campaigns = response.data;

                    this.loading = false;
                });
        },
        refreshJobs() {
            if(! this.show_job) {
                return;
            }

            this.clearJobs();

            this.loading = true;

            return axios.get(url(`admin/job-select/jobs`), { params: { campaign_id: this.campaign_id }})
                .then((response) => {
                    this.list.jobs = response.data;

                    this.loading = false;
                });
        },
        employerChanged() {
            this.refreshCampaigns();
            this.emitSelected();
        },
        campaignChanged() {
            this.refreshJobs();
            this.emitSelected();
        },
        jobChanged() {
            this.emitSelected();
        },
        emitSelected() {
            this.$emit('selected', {
                employer_id: this.employer_id,
                campaign_id: this.campaign_id,
                job_id: this.job_id
            })
        }
    },
    mounted() {
        this.refreshEmployers();
    }
};
</script>
